import { Component, Inject, OnInit, input } from '@angular/core';
import { IAdministrators } from '../store/state';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    standalone: false
})
export class ConfirmationComponent implements OnInit {
  userInfo = input<IAdministrators | null>(null);
  link: string;

  constructor(@Inject(DOCUMENT) private readonly docRef: Document) {
  }

  ngOnInit(): void {
    this.link = this.docRef.location.origin + '/' + this.docRef.location.pathname.split('/')[1];
  }

}
